export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите состояния ', trigger: 'blur' },
    ],
};
